import api from '..'

export async function getByCpf(cpf: string) {
  try {
    const response = await api.instance.get(`/customers/${cpf}`)
    return response.data
  } catch (error) {
    throw error
  }
}
